import { Component, Input } from '@angular/core';

import { IconColor } from '../../../common/icon/icon.component';
import { AttachmentPlaceloader } from './attachment-placeloader.types';

@Component({
  selector: 'rt-attachment-placeloader',
  templateUrl: 'attachment-placeloader.component.html',
  styleUrls: [
    '../attachment-item/attachment-item.component.less',
    './attachment-placeloader.component.less',
  ],
})
export class AttachmentPlaceloaderComponent {
  @Input() public attachmentPlaceloader: AttachmentPlaceloader;

  public IconColor = IconColor;
}
